import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";

import MainBurguerMenu from "./MainBurguerMenu";

import logoHome from "../../img/logo_home.png";
import rayo from "../../img/rayo.png";
import { ModalPlan } from "../../designs/modalEdit/ModalPlan";

const TITLES = [
    {
        id: 1,
        title: "Propietario",
        url: "funcionalidades-propietarios",
    },
    {
        id: 2,
        title: "Corredor Inmobiliario",
        url: "funcionalidades-corredores",
    },

    {
        id: 3,
        title: "Hotel",
        url: "funcionalidades-hoteles",
    },
    {
        id: 4,
        title: "Planes",
        url: "planes",
    },
    {
        id: 5,
        title: "Blog",
        url: "blog",
    },
];

interface Pros {
    calculadora?: string;
}

const MainNavbar = ({ calculadora }: Pros) => {
    const [titleSelected, setTitleSelected] = useState<number>(0);
    const [hoveredItem, setHoveredItem] = useState<number | null>(null);
    let hideTimeout: any;
    const [showOptions, setShowOptions] = useState(false);
    const [showRedBanner, setShowRedBanner] = useState(true);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { id, avatar, tipo_usuario } = useAppSelector(
        (state) => state.usuario_logeado
    );
    const [showModal, setShowModal] = useState(false);
    const { view, tags } = useParams();

    const handleSmoothScroll = (url: string) => {
        if (url === "blog") {
            navigate(`/${url}`);
        } else {
            navigate(`/home/${tags ? tags : "6"}/${url}`);
        }
    };

    useEffect(() => {
        if (view) {
            const element = document.getElementById(view);
            const marginTopToScroll = -90;
            if (element) {
                const elementYposition =
                    element?.getBoundingClientRect().top +
                    window.pageYOffset +
                    marginTopToScroll;

                window.scrollTo({ top: elementYposition, behavior: "smooth" });
            }
        }
    }, [view]);

    const handleMouseEnter = (id: any) => {
        clearTimeout(hideTimeout); // Cancela el temporizador de ocultación
        setHoveredItem(id); // Establece el estado como activo
    };

    const handleMouseLeave = () => {
        hideTimeout = setTimeout(() => setHoveredItem(null), 200); // Retraso para ocultar el menú
    };

    return (
        <div className="fixed top-0 z-50 w-full border-b border-[rgba(7,24,41,0.1)]">
            {showModal && (
                <ModalPlan
                    setModalVisibleComodidades={setShowModal}
                    modalVisibleComodidades={showModal}
                    comprar={false}
                />
            )}

            <div className="items-center justify-between hidden w-full  py-4 text-[#071829] md877:flex bg-[#FFFFFF] ">
                <div className="flex items-center justify-between 3xl:w-2/3 2xl:w-3/4 lg:w-4/5 w-5/6  mx-auto">
                    <span
                        onClick={() => handleSmoothScroll("inicio")}
                        className="font-medium cursor-pointer lg1170:mr-8 lg:text-lg"
                    >
                        <img
                            src={logoHome}
                            className=" xl:w-28 w-20  h-auto"
                            alt="logo blustay"
                        />
                    </span>
                    <div className="flex items-center gap-5 lg1170:gap-8">
                        {TITLES.map((title) => (
                            <div
                                key={title.id}
                                className="relative text-xs capitalize font-semibold cursor-pointer select-none lg:text-sm xl:text-base  2xl:text-lg "
                                onMouseEnter={() => handleMouseEnter(title.id)}
                                onMouseLeave={handleMouseLeave}
                            >
                                {/* Título principal */}
                                <div
                                    onClick={() => {
                                        if (title.url)
                                            handleSmoothScroll(title.url);
                                    }}
                                    className={`relative text-[#071829] hover:text-[#029DE0] `}
                                >
                                    <p>{title.title}</p>
                                    {/* Animación de línea */}
                                    <span
                                        className={`absolute bottom-0 left-0 h-0.5 bg-[#029DE0] transition-all duration-500 ${
                                            titleSelected === title.id ||
                                            hoveredItem === title.id
                                                ? "w-full"
                                                : "w-0"
                                        }`}
                                    ></span>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="flex gap-3 items-center lg:text-sm xl:text-base  2xl:text-lg text-xs">
                        <div
                            onClick={() => {
                                window.open(
                                    "https://calendar.app.google/7aKBqkaqESiPuTtE8"
                                );
                            }}
                            className="px-3 py-1.5 bg-[#029DE0] bg-opacity-10 text-[#029DE0] rounded-lg cursor-pointer hover:bg-opacity-25 "
                        >
                            Agenda tu demo
                        </div>

                        <div
                            onClick={() => setShowModal(true)}
                            className="flex justify-center items-center gap-1 px-3 py-1.5 bg-[#C3EA43] text-[#071829] font-semibold rounded-lg cursor-pointer overflow-hidden hover:scale-105 "
                        >
                            <img
                                src={rayo}
                                alt="rayo"
                                className="animate-rayoflash"
                            />{" "}
                            Crea tu página web
                        </div>
                    </div>
                </div>
            </div>
            <MainBurguerMenu
                className="md877:hidden"
                titles={TITLES}
                handleSmoothScroll={handleSmoothScroll}
                setShowModal={setShowModal}
            />
        </div>
    );
};

export default MainNavbar;
